import type { Messages } from "../types";

export const de = {
  "common": {
    "brand": "UN8",
    "brandTag": "Exklusives christliches Dating",
    "continue": "Weitermachen",
    "leave": "Verlassen",
    "leaveForNow": "Vorerst gehen",
    "yes": "Ja",
    "no": "NEIN",
    "goBack": "Geh zurück",
    "saving": "Sparen…",
    "submitting": "Einreichen…",
    "pleaseWait": "Bitte warten…",
    "ellipsis": "…",
    "male": "Männlich",
    "female": "Weiblich",
    "phases": {
      "gate": "Tor",
      "verify": "Verifizieren",
      "setup": "Aufstellen",
      "profile": "Profil"
    },
    "storageQuota": "Auf diesem Telefon ist nicht mehr genügend Speicherplatz für gespeicherte Antworten vorhanden. Gib etwas Speicherplatz frei und versuch es dann erneut.",
    "storageDisabled": "Dieser Browser speichert deine Antworten nicht. Deaktiviere den privaten Modus oder lass Site-Daten zu und lade dann neu.",
    "charMeta": "{len}/{min} Min. · {current}/{max}",
    "charMetaMin": "min. {min} Zeichen"
  },
  "welcome": {
    "promise": "Unser Ziel ist es, dass du diese App so schnell wie möglich löschst.",
    "sub": "UN8 hilft ernsthaften christlichen Singles, einen Lebenspartner zu finden – und dann zu gehen. Verifiziert. Werte zuerst. Kein endloses Wischen.",
    "signedInAs": "Angemeldet als {email}",
    "liveServer": "· Live-Server",
    "deviceOnly": "· Nur dieses Gerät",
    "migrateOffer": "Dieses Gerät verfügt noch über ein lokales Profil. Lade es auf den gemeinsam genutzten Server hoch, damit andere Telefone dich nach der Moderation sehen können? Es wird nichts hochgeladen, bis du eine Auswahl triffst.",
    "uploadLocalProfile": "Lade mein lokales Profil hoch",
    "keepOnDevice": "Behalte es nur auf diesem Gerät",
    "migrateNeedGender": "Wähl in deinem Profil zunächst „Männlich“ oder „Frau“ aus.",
    "migrateDone": "Profiltext hochgeladen. Lade den Ausweis, das Video und die Fotos erneut hoch, damit die Moderation sie überprüfen kann.",
    "deleteConfirm": "Dein Konto, alle Nachrichten und alle Medien (einschließlich ID und Video) dauerhaft vom Server löschen?",
    "accountDeleted": "Konto gelöscht.",
    "begin": "Beginnen",
    "continueOnboarding": "Onboarding fortsetzen",
    "logIn": "Einloggen",
    "logOut": "Abmelden",
    "reviewConsole": "Review-Konsole",
    "matching": "Partnersuche",
    "deleteMyAccount": "Mein Konto löschen"
  },
  "faith": {
    "eyebrow": "Glaubenstor",
    "title": "Ich folge Jesus Christus",
    "text": "UN8 ist für Nachfolger Jesu Christi.",
    "yesTitle": "Ja",
    "yesBody": "",
    "noTitle": "Nein",
    "noBody": "",
    "respectTitle": "Mit Respekt",
    "respectBody": "UN8 ist für eine Community konzipiert und wir möchten lieber ehrlich sein, als deine Zeit zu verschwenden. Benutze „Unten verlassen“ oder „Zurück“, wenn dies nicht dein Zuhause ist.",
    "sharedTitle": "Gemeinsames Fundament",
    "sharedBody": "Glaube ist hier kein Etikett. Es ist der Boden, auf dem ihr euch begegnet.",
    "hintNotChristian": "UN8 richtet sich an Nachfolger Jesu Christi. Tippe unten auf Verlassen, oder auf Ja, wenn das du bist.",
    "hintUnset": "Tippe auf Ja, um fortzufahren, oder auf Verlassen / Zurück, wenn dies nicht dein Zuhause ist."
  },
  "rules": {
    "eyebrow": "Gemeinschaftsbund",
    "title": "Wie wir miteinander umgehen",
    "text": "Bestätige jede Regel. Alle drei sind erforderlich. Verstöße führen zur dauerhaften Entfernung. Fake-Profile werden für immer gesperrt.",
    "agreeContinue": "Ich stimme zu – weiter",
    "respectful": {
      "title": "Sei respektvoll",
      "description": "Sprechen und handeln du mit Würde. Jeder Mensch hier ist nach Gottes Bild geschaffen."
    },
    "noSexualContent": {
      "title": "Kein sexueller Inhalt",
      "description": "Keine expliziten Fotos, Nachrichten oder Anfragen. Reinheit ist hier nicht optional."
    },
    "noDominance": {
      "title": "Dominiere oder kontrollier niemanden",
      "description": "Kein Zwang, Manipulation oder Druck. Liebe kontrolliert nicht."
    },
    "hint": "Kreuze alle drei Versprechen an, bevor du weitergehst."
  },
  "intent": {
    "eyebrow": "",
    "title": "Wonach suchst du?",
    "text": "",
    "marriage": {
      "label": "Einen Lebenspartner",
      "description": ""
    },
    "discernment": {
      "label": "Heirat, in einem oder zwei Jahren",
      "description": ""
    },
    "notCasual": {
      "label": "Erst Freundschaft, dann sehen",
      "description": ""
    },
    "hint": "Wähle eines."
  },
  "account": {
    "eyebrow": "Konto",
    "title": "Erstell deinen Zugang",
    "text": "Dein Handle erstellt eine stabile Benutzer-ID. Bewerbung, Verifizierung, Likes und Übereinstimmungen sind alle an diese ID gebunden. Es wird keine E-Mail gesendet.",
    "recoveryTitle": "Speicher deinen Wiederherstellungscode",
    "recoveryText": "Einmal gezeigt. Ohne sie kann eine verlorene Passphrase in diesem geschlossenen Test nicht zurückgesetzt werden.",
    "savedContinue": "Ich habe es gespeichert – weiter",
    "handle": "Handhaben",
    "handlePlaceholder": "you@example.com oder ein kurzer Handle",
    "passphrase": "Passphrase",
    "passphrasePlaceholder": "Mindestens 8 Zeichen",
    "signedInTitle": "Angemeldet",
    "signedInBody": "{email} · {userId}",
    "trustTitle": "Vertrauensstandard",
    "trustBody": "Es ist kein Profil sichtbar, bis die Identitätsüberprüfung abgeschlossen ist und die Moderation dich freigibt.",
    "continueToVerification": "Weiter zur Verifizierung",
    "hintEmail": "Gib eine E-Mail-Adresse ein, die @ enthält.",
    "hintPassword": "Wähl ein Passwort mit mindestens 8 Zeichen."
  },
  "verify": {
    "intro": {
      "eyebrow": "Überprüfung",
      "title": "Vertrauen ist das Tor",
      "text": "Lade einen amtlichen Ausweis, ein Bestätigungsvideo und echte Fotos {min}–{max} hoch. Alles gelangt in eine Überprüfungswarteschlange, bevor dein Profil angezeigt werden kann.",
      "whyTitle": "Warum wir verifizieren",
      "whyBody": "Welse und Halbwahrheiten haben hier keinen Platz. Fake-Profile werden dauerhaft gesperrt. Medien werden bis zur Genehmigung mit dem Status pending_review gespeichert.",
      "start": "Verifizierung starten"
    },
    "steps": {
      "id": {
        "title": "Regierungsausweis",
        "description": "Reisepass oder Personalausweis – Kamera oder Datei-Upload."
      },
      "video": {
        "title": "Bestätigungsvideo",
        "description": "Eine kurze Aufnahme, die beweist, dass du es bist."
      },
      "photos": {
        "title": "Echte Fotos",
        "description": "Sieben bis zehn klare Fotos von dir."
      },
      "review": {
        "title": "Integritätsprüfung",
        "description": "Uploads bleiben pending_review, bis das Personal sie bestätigt."
      }
    },
    "id": {
      "eyebrow": "Schritt 1 von 4",
      "title": "Regierungsausweis",
      "text": "Erfassen oder lade deinen Reisepass oder Personalausweis hoch. Es wird nichts öffentlich gepostet – der Status bleibt pending_review, bis die Mitarbeiter dies bestätigen.",
      "savedTitle": "ID gespeichert",
      "savedBody": "Als nächstes folgt ein kurzes Bestätigungsvideo deines Gesichts, dann {min}–{max} echte Fotos von dir. Wird weiterhin entsperrt, wenn diese ID als gespeichert angezeigt wird.",
      "hint": "Mach ein Foto deines amtlichen Ausweises oder lade es hoch und warte dann, bis „Gespeichert“ angezeigt wird."
    },
    "video": {
      "eyebrow": "Schritt 2 von 4",
      "title": "Bestätigungsvideo",
      "text": "Nimm einen kurzen Clip auf oder lade einen hoch. Schau in die Kamera. Sprich deutlich. Das beweist, dass du da bist – und keine abgekratzte Galerie.",
      "hint": "Nimm ein kurzes Bestätigungsvideo auf und warte, bis „Gespeichert“ angezeigt wird."
    },
    "photos": {
      "eyebrow": "Schritt 3 von 4",
      "title": "Echte Fotos",
      "text": "Füge {min}–10 aktuelle Fotos von dir hinzu. Benutze die Kamera oder deine Bibliothek. Tippe auf ×, um eine Aufnahme zu entfernen.",
      "continueToReview": "Weiter zur Prüfung",
      "hint": "Füge {min} bis 10 klare Fotos von dir hinzu. Weiter geht es, sobald sie gespeichert sind."
    },
    "review": {
      "eyebrow": "Schritt 4 von 4",
      "title": "Integritätsprüfung",
      "text": "Medien werden als pending_review{underUser} in die Warteschlange gestellt. Matches und Likes verwenden dieselbe ID.",
      "underUser": "unter dem Benutzer {userId}",
      "governmentId": "Regierungsausweis",
      "confirmationVideo": "Bestätigungsvideo",
      "photos": "Fotos",
      "missing": "Fehlen",
      "filesReady": "{count}-Dateien bereit",
      "submittedTitle": "Zur Überprüfung eingereicht",
      "submittedText": "Die Anwendungs-ID entspricht der Authentifizierungsbenutzer-ID, also genehmigen → Pool und gegenseitige Likes bleiben aufeinander abgestimmt.",
      "submitContinue": "Senden und fortfahren"
    }
  },
  "setup": {
    "eyebrow": "Kontoeinrichtung",
    "title": "Sag die Wahrheit über dich",
    "text": "Diese Antworten passen zusammen und werden in der Überprüfung angezeigt. Sanfte Lügen verschwenden die Zeit aller – auch deiner.",
    "beginSetup": "Einrichtung beginnen",
    "pillars": {
      "faith": {
        "name": "Glaube",
        "text": "Warum du Christus folgst."
      },
      "character": {
        "name": "Charakter",
        "text": "Loyalität, Ehrlichkeit, Leidenschaft, Engagement – ​​bewertet mit 1–10."
      },
      "story": {
        "name": "Geschichte",
        "text": "Wer du bist und was du suchst."
      },
      "life": {
        "name": "Leben",
        "text": "Hobbys, Lesen und Berufung."
      }
    },
    "whyChristian": {
      "eyebrow": "Glaube",
      "title": "Warum bist du Christ?",
      "text": "Eine kurze, ehrliche Antwort. Keine Predigt – ein Grund, der dir gehört.",
      "label": "Deine Antwort",
      "placeholder": "z.B. Ich habe Christus in einer Zeit des Verlusts kennengelernt und bin ihm seitdem gefolgt ...",
      "hint": "Schreib mindestens {min} Zeichen darüber, warum du Jesus nachfolgen."
    }
  },
  "scales": {
    "eyebrow": "Charakterskalen",
    "title": "Bewerte dich ehrlich",
    "text": "Loyalität, Ehrlichkeit, Leidenschaft, Engagement – jeweils von 1 bis 10. Geselligkeit ist optional. Das Aufblähen von Zahlen führt später nur zu einer Fehleinschätzung.",
    "loyalty": {
      "label": "Grad der Loyalität",
      "hint": "Sei ehrlich – wie treu stehst du zu denen, die du liebst?"
    },
    "honesty": {
      "label": "Maß an Ehrlichkeit",
      "hint": "Wie konsequent sagst du die volle Wahrheit?"
    },
    "passion": {
      "label": "Wie leidenschaftlich bist du?",
      "hint": "Überzeugung und Tiefe – keine Leistung."
    },
    "commitment": {
      "label": "Grad des Engagements",
      "hint": "Wie bereit bist du, etwas zu bauen, das von Dauer ist?"
    },
    "social": {
      "label": "Geselligkeit",
      "hint": "Ruhige Abende an einem Ende. Ein voller Raum am anderen."
    },
    "hint": "Stell Loyalität, Ehrlichkeit, Leidenschaft und Engagement ein."
  },
  "about": {
    "eyebrow": "Über dich",
    "title": "Beschreib dich in ein paar Sätzen",
    "text": "Wer du bist, wenn niemand auftritt. Temperament, Rhythmus, worauf es im Alltag ankommt.",
    "label": "Über dich",
    "placeholder": "Ruhige Morgen, ernst mit der Familie, leicht lachen, lieber Tiefe als Lärm …",
    "hint": "Schreib mindestens {min} Zeichen über dich."
  },
  "looking": {
    "eyebrow": "Partner",
    "title": "Wonach suchst du?",
    "text": "Die wichtigsten Charaktereigenschaften, die du bei einem Partner wichtig findest – keine Einkaufsliste mit Looks.",
    "label": "Gewünschte Charaktereigenschaften",
    "placeholder": "z.B. Unerschütterlicher Glaube, emotionale Reife, Freundlichkeit unter Stress …",
    "hint": "Schreib mindestens {min} Zeichen über den Partner, den du dir vorstellst."
  },
  "loveReady": {
    "eyebrow": "Schwelle",
    "title": "Bist du bereit, die Liebe deines Lebens zu treffen?",
    "text": "UN8 existiert, damit ernsthafte Singles einen Partner finden – und dann die App löschen. Nur „Ja“-Entsperrungen werden fortgesetzt.",
    "yesTitle": "Ja – ich bin bereit",
    "yesBody": "Ich bin hier, um meiner Person mit Klarheit und Mut zu begegnen.",
    "noTitle": "Noch nicht",
    "noBody": "Wenn du nur schaust, ist diese Community nicht die richtige Wahl.",
    "comeBackTitle": "Komm zurück, wenn du bereit bist",
    "comeBackBody": "UN8 richtet sich an Menschen, die bereit sind, sich zu treffen – und nicht, um Optionen zu sammeln. Benutze „Verlassen“ unten, wenn du vorerst Pause machen willst. Deine Antworten bleiben auf diesem Telefon.",
    "hintNo": "Es bleibt nur „Ja“. Wenn du noch nicht bereit bist, tippe auf „Vorerst verlassen“ – deine Antworten bleiben auf diesem Telefon.",
    "hintUnset": "Tippe auf „Ja“, wenn du bereit bist, jemanden zum Heiraten zu treffen."
  },
  "lifestyle": {
    "eyebrow": "Lebensstil",
    "title": "Wie du Tag für Tag lebst",
    "text": "Sport, Hobbys, Lesen und Beruf – praktische Signale für echte Vereinbarkeit.",
    "hobbies": "Aktuelle Sportarten oder Hobbys",
    "hobbiesPlaceholder": "Was du aktiv machst – nicht das, was du früher gemacht hast.",
    "reading": "Liest du?",
    "readingHint": "1 = fast nie · 10 = täglich, intensiv lesen",
    "profession": "Beruf / Branche",
    "professionPlaceholder": "z.B. Krankenpflege · Software · Bildung · Handwerk",
    "hintHobbies": "Nenn mindestens eine Sportart oder ein Hobby, das du wirklich machst.",
    "hintReading": "Folie „Liest du?“ Es wird also eine Zahl von 1 bis 10 angezeigt.",
    "hintProfession": "Gib deine Arbeit ein, sogar ein kurzes Wort."
  },
  "faithDepth": {
    "eyebrow": "Passend · Glaube",
    "title": "Wie zentral ist dein Glaube?",
    "text": "Gott dienen – wie wichtig ist es in deinem Leben? Antworte ehrlich. Beim Matching wird dies für die Tiefe und nicht für die Leistung verwendet.",
    "serving": "Gott dienen – wichtig",
    "servingHint": "10 % … 100 %. Schieb in 10er-Schritten.",
    "keepsCommandments": "Hältst du die Gebote?",
    "grewUpInChurch": "Bist du in der Kirche aufgewachsen?",
    "churchAttendance": "Kirchenbesuch",
    "frequent": {
      "label": "Häufig",
      "hint": "Regelmäßige Zusammenkunft mit dem Leib Christi."
    },
    "seldom": {
      "label": "Selten",
      "hint": "Gelegentlich kein wöchentlicher Rhythmus."
    },
    "never": {
      "label": "Niemals",
      "hint": "Derzeit nicht anwesend."
    },
    "spreadsGospel": "Verbreitest du das Evangelium?",
    "hasIdols": "Hast du Idole?",
    "hintServing": "Schieb, wie wichtig es ist, Gott in deinem Leben zu dienen.",
    "hintCommandments": "Antworte, ob du die Gebote befolgst – Ja oder Nein.",
    "hintGrewUp": "Antworte, ob du in der Kirche aufgewachsen bist: Ja oder Nein.",
    "hintAttendance": "Wähl, wie oft du in die Kirche gehst.",
    "hintGospel": "Antworte, ob du das Evangelium teilst: Ja oder Nein.",
    "hintIdols": "Antworte, ob du Idole hast: Ja oder Nein."
  },
  "character": {
    "eyebrow": "Passender · Charakter",
    "title": "Wer du zu Hause bist",
    "text": "Charakter für die Werbung – Frieden stiftend, Manieren, Ehrlichkeit. Das Aufblähen von Antworten führt später nur zu falschen Ergebnissen.",
    "peacemaker": "Bist du ein Friedensstifter?",
    "homebuilder": "Bist du ein Hausbauer?",
    "humorous": "Bist du humorvoll?",
    "caring": "Fürsorglich und liebevoll?",
    "peacefulHome": "Möchtest du ein friedliches Zuhause – frei von Kämpfen?",
    "manners": "Gute Manieren?",
    "honestyRating": "Ehrlichkeitsbewertung in diesem Fragebogen",
    "honestyHint": "1–10 – Wie ehrlich antwortest du?",
    "hintPeacemaker": "Beantworte jede Frage mit „Ja“ oder „Nein“ und beginn mit „Friedensstifter“.",
    "hintHomebuilder": "Beantworte, ob du ein Hausbauer bist.",
    "hintHumorous": "Antworte, ob du humorvoll bist.",
    "hintCaring": "Antworte, ob du fürsorglich und liebevoll bist.",
    "hintPeaceful": "Beantworte, ob du ein ruhiges Zuhause willst.",
    "hintManners": "Beantworte, ob du gute Manieren hast.",
    "hintHonesty": "Schieb deine Ehrlichkeitsbewertung von 1 auf 10."
  },
  "history": {
    "eyebrow": "Matching · Geschichte",
    "title": "Vergangenheit und Bereitschaft",
    "text": "Substanzen, Kindheit, Narben und ob du für eine dauerhafte Beziehung bereit bist. Die Wahrheit hier schützt euch beide.",
    "marijuana": "Hast du Marihuana konsumiert?",
    "lsd": "Hast du LSD genommen?",
    "otherDrugs": "Hast du andere Drogen genommen?",
    "addicted": "Warst du süchtig?",
    "childhood": "Stabile, liebevolle Kindheit?",
    "scars": "Irgendwelche Narben/Beschädigungen?",
    "lasting": "Bereit für eine dauerhafte Beziehung?",
    "hintStart": "Beantworte auf dieser Seite alle Fragen mit „Ja“ oder „Nein“, beginnend oben.",
    "hintLsd": "Beantworte die LSD-Frage: Ja oder Nein.",
    "hintOtherDrugs": "Antworte, ob du andere Drogen genommen hast.",
    "hintAddicted": "Antworte, ob du süchtig warst.",
    "hintChildhood": "Beantworte, ob deine Kindheit stabil und liebevoll war.",
    "hintScars": "Beantworte, ob du Narben hast.",
    "hintLasting": "Beantworte, ob du für eine dauerhafte Beziehung bereit bist."
  },
  "appearance": {
    "eyebrow": "Passend · Aussehen",
    "title": "Tätowierungen",
    "text": "Deine Tätowierungen und ob Tätowierungen bei einem Partner für dich okay sind.",
    "hasTattoos": "Hast du Tätowierungen?",
    "acceptsPartner": "Tätowierungen bei einem Partner akzeptieren?",
    "hintHas": "Sag, ob du Tätowierungen hast – Ja oder Nein.",
    "hintAccepts": "Sag, ob Tätowierungen bei deinem Partner für dich okay sind."
  },
  "home": {
    "eyebrow": "Matching · Haus & Grundstück",
    "title": "Land, Fähigkeiten, Selbstversorgung",
    "text": "Kräuter, Nahrungsmittelanbau, Obstwald, Zubereitung, gemeinschaftliche Landwirtschaft, Konservieren, Überleben – und alle besonderen Fähigkeiten.",
    "herbKnowledge": "Kräuterwissen?",
    "plantOwn": "Pflanzt du dein eigenes Obst und Gemüse an?",
    "fruitForest": "Interessiert an einem Obstwald?",
    "prepping": "Bereitest du dich auf Katastrophen vor?",
    "communityFarming": "Gemeinschaftslandwirtschaft / unabhängiges Leben?",
    "canning": "Einmachen und Konservieren?",
    "survival": "Überlebensfähigkeiten?",
    "specialSkills": "Besondere Fähigkeiten (optional)",
    "specialPlaceholder": "Alles andere, was du in einen Haushalt oder ein Grundstück mitbringst …",
    "hintStart": "Beantworte alle Fragen zu Land und Fertigkeiten mit „Ja“ oder „Nein“, beginnend ganz oben.",
    "hintPlant": "Beantworte, ob du dein eigenes Obst und Gemüse anbaust.",
    "hintFruitForest": "Beantworte, ob du ein Obstwald interessiert.",
    "hintPrepping": "Beantworte, ob du auf Katastrophen vorbereitet bist.",
    "hintCommunity": "Beantworte, ob du an gemeinschaftlicher Landwirtschaft interessiert bist.",
    "hintCanning": "Beantworte, ob du Lebensmittel einkochen kannst.",
    "hintSurvival": "Beantworte, ob du Überlebensfähigkeiten hast."
  },
  "family": {
    "eyebrow": "Passend · Familie",
    "title": "Kinder, Glaubenstiefe, Substanzen",
    "text": "Was du bei einem Partner brauchst: Glaubensintensität, Kinder und früherer Substanzkonsum.",
    "children": "Kinder",
    "wants": {
      "label": "Will Kinder",
      "hint": "Eine Familie zu gründen ist Teil der Vision."
    },
    "doesNotWant": {
      "label": "Will keine Kinder",
      "hint": "Klares Nein zu Kindern."
    },
    "open": {
      "label": "Offen",
      "hint": "Anspruchsvoll – in keiner Weise verschlossen."
    },
    "hasLivingWith": {
      "label": "Hat Kinder und lebt mit ihnen zusammen",
      "hint": "Kinder gehören bereits zum täglichen Leben."
    },
    "requiredFaith": "Mindestglaube, den du bei einem Partner brauchst",
    "requiredFaithHint": "10 % … 100 %. Hartes Tor, wenn beide Seiten geantwortet haben.",
    "acceptsSubstances": "Früheren Substanzkonsum bei einem Partner akzeptieren?",
    "hintChildren": "Wähl eine Karte zu Kindern.",
    "hintFaith": "Schieb das Mindestglaubensniveau, das du bei einem Partner erwartest.",
    "hintSubstances": "Sag, ob früherer Substanzkonsum bei einem Partner akzeptabel ist."
  },
  "ancestry": {
    "eyebrow": "Passender · Hintergrund",
    "title": "Hintergrundeinstellungen",
    "text": "Teile deinen Hintergrund und deine Offenheit gegenüber einem Partner mit. Dies prägt lediglich die Rangfolge – es verbirgt niemals jemanden vor dem Deck.",
    "yourBackground": "Dein Hintergrund (alles Zutreffende auswählen)",
    "openToPartner": "Offen für einen Partner",
    "codeDesc": "Code: {code}",
    "anyDesc": "Stärkste Präferenz für Breite – empfohlen, wenn du unsicher bist.",
    "preferenceOnly": "Nur Präferenz – kein Tor.",
    "hintOwn": "Kreuze mindestens einen Hintergrund an, der dich beschreibt. Das hilft nur beim Ranking – es verbirgt niemanden.",
    "hintAccepted": "Kreuze an, wofür du bei einem Partner offen bist, oder „Offen – egal“."
  },
  "interests": {
    "eyebrow": "Passende · Interessen",
    "title": "Was dir Spaß macht",
    "text": "Wähl mindestens eine aus. Überlappung hilft beim Ranking; Schweigen wird niemals bestraft.",
    "hint": "Kreuze mindestens ein Interesse an."
  },
  "reflection": {
    "eyebrow": "Matching · Reflexion",
    "title": "In deinen eigenen Worten",
    "text": "Diese vier Antworten werden vollständig angezeigt und nie bewertet. Schreib, was wahr ist.",
    "describeYourself": "Beschreibe dich",
    "lifePurpose": "Lebenszweck",
    "fifteenYear": "Du und die Liebe deines Lebens in 15 Jahren",
    "weaknesses": "Schwächen",
    "hintDescribe": "Beschreib dich mit mindestens {min} Zeichen.",
    "hintPurpose": "Schreib deinen Lebenszweck in mindestens {min} Zeichen.",
    "hintVision": "Schreib die 15-Jahres-Vision in mindestens {min} Zeichen.",
    "hintWeaknesses": "Nenn eine Schwachstelle in mindestens {min} Zeichen."
  },
  "profile": {
    "eyebrow": "Profil",
    "title": "Ein paar wesentliche Dinge",
    "text": "Halt es einfach. Zur eindeutigen Zuordnung ist das Geschlecht hier binär – männlich oder weiblich.",
    "firstName": "Vorname",
    "firstNamePlaceholder": "Wie du genannt werden möchtest",
    "age": "Alter",
    "agePlaceholder": "18+",
    "city": "Stadt",
    "cityPlaceholder": "Wo du wohnst",
    "sex": "Geschlecht",
    "maleBody": "Ich bin ein Mann.",
    "femaleBody": "Ich bin eine Frau.",
    "hintName": "Gib deinen Vornamen ein (mindestens zwei Buchstaben).",
    "hintAge": "Das Alter muss 18 Jahre oder älter sein.",
    "hintCity": "Gib die Stadt ein, in der du lebst.",
    "hintGender": "Wähl „Männlich“ oder „Frau“, damit die Zuordnung funktioniert."
  },
  "ready": {
    "title": "Du darfst eintreten.",
    "textNamed": "{name}, deine Überprüfung und Einrichtung werden aufgezeichnet. Medien sind pending_review. Willkommen bei UN8 – finde deine Person und lösch dann die App.",
    "text": "Deine Verifizierung und Einrichtung werden aufgezeichnet. Medien sind pending_review. Willkommen bei UN8 – finde deine Person und lösch dann die App.",
    "summaryAria": "Setup-Zusammenfassung",
    "christianRules": "Christliche · Regeln bekräftigt",
    "mediaLine": "ID · Video · {photoCount} Fotos · Warteschlange {pending}",
    "scalesLine": "Skalen L{loyalty}/H{honesty}/P{passion}/C{commitment}",
    "genderProfession": "{gender} · {profession}",
    "sexUnset": "Geschlecht —",
    "professionFallback": "Beruf",
    "userLine": "Benutzer {userId}",
    "enterMatching": "Zum Matching",
    "needGender": "Geh zurück zum Profilschritt, wähl „Männlich“ oder „Frau“ und versuch es dann erneut."
  },
  "match": {
    "brandTag": "Partnersuche",
    "navOnboarding": "Einrichtung",
    "navReview": "Moderation",
    "navMatching": "Partnersuche",
    "logOut": "Abmelden",
    "quietSignIn": "Anmelden",
    "enterTitle": "Zum Matching",
    "enterText": "Meld dich mit derselben E-Mail-Adresse wie beim Onboarding an. Anwendung, Pool, Likes und Matches verwenden alle deine stabile Benutzer-ID.",
    "email": "E-Mail",
    "emailPlaceholder": "du@beispiel.com",
    "password": "Passwort",
    "passwordPlaceholder": "Dein Passwort",
    "logIn": "Einloggen",
    "guestOr": "Oder versuch es mit einer Gastsitzung (stabile ID pro Browser · nur Demo)",
    "guestMan": "Gast als Mann",
    "guestWoman": "Gast als Frau",
    "goOnboarding": "Zum Onboarding →",
    "guestSession": "Gastsitzung · Demo-Auswahl",
    "man": "Mann",
    "woman": "Frau",
    "tabToday": "Auswahl",
    "tabMatches": "Übereinstimmungen ({count})",
    "yourMatches": "Deine Streichhölzer",
    "matchesSub": "Anhaltendes gegenseitiges Interesse · {count} ausgehende {likesWord}",
    "like": "Like",
    "likes": "Likes",
    "emptyMatches": "Noch kein gegenseitiges Interesse. Unterscheide weiter die Auswahl dieser Woche.",
    "valuesScore": "Werte {score}",
    "chatOpen": "· Chat geöffnet",
    "tapToChat": "· Tippe zum Chatten",
    "personLine": "{name}, {age}",
    "cityValues": "{city} · Werte {score}",
    "noProfileYet": "Noch kein Profil",
    "noProfileText": "Beende das Onboarding oder tippe oben auf „Onboarding“ und dann auf „Starten“. Die Gastzuordnung erfolgt auf dem Eingabebildschirm, wenn du nur schauen möchtest.",
    "matchingPaused": "Abgleich pausiert",
    "noOneYet": "Noch niemand zu zeigen",
    "todaysSetDone": "Das ist die Auswahl dieser Woche",
    "weeklyTitle": "Deine 4 diese Woche",
    "weeklyTitleCount": "Deine {count} diese Woche",
    "weeklyCountdown": "Nächste Auswahl in {days} Tagen",
    "weeklyCountdownOne": "Nächste Auswahl in 1 Tag",
    "weeklyCountdownSoon": "Nächste Auswahl bald",
    "shortWeekCopy": "Diese Woche gibt es {count}. Wir schlagen niemanden vor, der nicht passt.",
    "shortWeekTwo": "Diese Woche gibt es zwei. Wir schlagen niemanden vor, der nicht passt.",
    "weekDone": "Das ist die Auswahl dieser Woche",
    "weekDoneText": "Du hast alle durchgesehen, die wir ehrlich vorschlagen konnten. Komm zur nächsten Auswahl zurück.",
    "emptyNeverHad": "In der Liste dieser Woche steht noch niemand. Der Pool füllt sich — öffne die Auswahl gleich erneut, oder komm wieder, wenn weitere Mitglieder freigegeben sind.",
    "emptyDone": "Du hast die Auswahl dieser Woche gesehen. Komm zur nächsten Freigabe zurück, oder setz die Auswahl zurück.",
    "likesMayNotStick": "Likes bleiben möglicherweise nicht hängen.",
    "poolMeta": "Auswahl: {pool} · Matches: {matches} · Likes: {liked}",
    "demoPool": "Demo",
    "livePool": "{source} ({count})",
    "resetDeck": "Auswahl zurücksetzen",
    "backOnboarding": "Zurück zum Onboarding",
    "feedEyebrowDemo": "Wochenauswahl · Demo",
    "feedEyebrowLive": "Wochenauswahl · Pool ({source}, {count})",
    "feedTitle": "Wähle mit Bedacht",
    "left": "noch {count}",
    "pass": "Passieren",
    "interested": "Interessiert",
    "likeHeart": "Like geben",
    "flame": "Flame geben",
    "flameNoneLeft": "Diese Woche keine Flamme mehr. Am Montag kommt sie zurück.",
    "flameLead": "Gib {name} eine Flame.",
    "flameOnly": "Nur Flamme",
    "flameSend": "Flame senden",
    "heartBurstTitle": "Like für {name}",
    "flameBurstTitle": "Eine Flamme für {name}",
    "flameSent": "Du hast {name} eine Flamme geschickt.",
    "flipNeedsLike": "Gib ein Like, um die Karte zu drehen.",
    "likedStays": "Ein Like bleibt. Du kannst es nicht zurücknehmen.",
    "composeCancel": "Abbrechen",
    "heartsNoneLeft": "Diese Woche keine Herzen mehr. Am Montag bekommst du neue.",
    "commentLead": "Gib {name} ein Like.",
    "commentPlaceholder": "33 Buchstaben, nicht mehr",
    "commentCount": "{count} / {max}",
    "commentSend": "Like senden",
    "heartOnly": "Nur Herz",
    "commentTooLong": "Das sind mehr als {max} Buchstaben. Das Herz ging raus; die Notiz nicht.",
    "commentAnchors": {
      "about": "Über mich",
      "lookingFor": "Ich suche",
      "hobbies": "Interessen",
      "photo": "Foto"
    },
    "inboundTitle": "Hat dich geliked",
    "likeBack": "Zurückliken",
    "cardStatLoyalty": "LOY",
    "cardStatHonesty": "HON",
    "cardStatPassion": "PAS",
    "cardStatCommit": "COM",
    "cardStatSocial": "SOC",
    "cardStatFaith": "GLA",
    "cardStatCharacter": "CHA",
    "cardStatPurpose": "ZWE",
    "cardStatHome": "HEI",
    "cardStatAncestry": "HER",
    "cardStatTemper": "TEM",
    "goToProfile": "Zum Profil",
    "goToProfileChat": "Profil & Chat",
    "holdToPeek": "{name}s Karte halten für Werte",
    "holdOrOpenProfile": "Halten für Werte, tippen für {name}s Profil",
    "likeToOpenProfile": "Liken, um das volle Profil zu öffnen",
    "waitLikeBack": "Warten, bis {name} zurückliket — dann öffnet der Chat.",
    "flipToStats": "{name}s Werte zeigen",
    "flipToPhoto": "{name}s Foto zeigen",
    "likeToFlip": "Halten für Werte. Liken fürs volle Profil.",
    "swipeHint": "Ein Pass wird innerhalb von 24 Stunden ersetzt, wenn jemand anderes passt. Wir füllen nie mit einem schlechten Match auf.",
    "celebrationEyebrow": "Gegenseitiges Interesse",
    "celebrationTitle": "Du hast gepasst",
    "celebrationText": "{self} · {other}",
    "celebrationNote": "",
    "openChat": "Chat öffnen",
    "keepDiscerning": "Bleib aufmerksam",
    "cardSeeking": "Ich suche",
    "matchingScore": "Matching-Score",
    "affinity": "Matching-Score",
    "valuesScoreLabel": "Matching-Score",
    "cardHobbies": "Hobbys",
    "scoreStrong": "Starke Ausrichtung",
    "scoreSolid": "Solide Ausrichtung",
    "scoreModerate": "Mäßige Ausrichtung",
    "scoreDifferent": "Verschiedene Rhythmen",
    "characterAxisFoot": "Die Charakterachse umfasst die vier Säulen",
    "youThem": "Du {self} · du {other}",
    "stampInterest": "Interesse",
    "stampPass": "Passieren",
    "explainLegacyClose": "Deine Wertwerte liegen nahe beieinander ({score} von 100).",
    "explainLegacyFuller": "Ein ausführlicheres „Warum“ erscheint, nachdem ihr beide die passenden Fragen beantwortet habt.",
    "explainFaith": "Deine Glaubensintensität ist vergleichbar – Du nimmst die Nachfolge Jesu mit ähnlicher Ernsthaftigkeit wahr.",
    "explainCharacter": "Wie du die Menschen zu Hause behandeln, stimmt überein – Frieden, Manieren und Fürsorge.",
    "explainPurpose": "Du bewertest deine eigene Ehrlichkeit ähnlich, was ein Zeichen gemeinsamer Ernsthaftigkeit ist.",
    "explainHome": "Du hast ein gemeinsames Interesse an Land, dem Anbau von Nahrungsmitteln oder einem autarken Zuhause.",
    "explainAncestry": "Dein bevorzugt beide einen ähnlichen familiären Hintergrund. Das ist eine Präferenz, kein Filter – niemand bleibt dafür verborgen.",
    "explainTemperament": "Deine Interessen und dein Temperament überschneiden sich.",
    "explainFallback": "Möglicherweise stimmen die von euch beiden eingegebenen Antworten überein.",
    "explainOverall": "Matching-Score {score}/100",
    "affinityAxes": {
      "faith": "Glaubensintensität",
      "character": "Charakter und Verhalten",
      "purpose": "Ausrichtung des Lebenszwecks",
      "home": "Zuhause & Selbstversorgung",
      "ancestry": "Kultur- und Hintergrundaffinität",
      "temperament": "Temperamentpassung"
    },
    "scaleAxes": {
      "loyalty": "Loyalität",
      "honesty": "Ehrlichkeit",
      "passion": "Hingabe",
      "commitment": "Engagement"
    },
    "waitingModeration": "Dein Profil wartet auf Freigabe durch die Moderation, bevor die Auswahl öffnet.",
    "completeProfileFirst": "Schließ zuerst dein Profil ab und reich es ein.",
    "moderationDemoNote": "Wir zeigen Demo-Personen, damit du Matching schon testen kannst.",
    "navSelection": "Auswahl",
    "navWhoLiked": "Hat dich geliked",
    "navMessages": "Nachrichten",
    "navProfile": "Profil",
    "packTitle": "Deine vier",
    "packSkip": "Tippen zum Fortfahren",
    "refreshTitle": "Neue Auswahl",
    "newSelection": "Neue Auswahl",
    "backToFour": "← Zurück zu deinen vieren",
    "whoLikedTitle": "Sieh, wer dich mag",
    "whoLikedHint":
      "Like zurück — dann seid ihr ein Match. Chat ist danach länger als dreiunddreißig Buchstaben.",
    "whoLikedEmpty": "Noch niemand Neues hat dich geliked.",
    "whoLikedLocked": "Abonnieren, um Namen in der Wochenauswahl zu sehen — eingehende Herzen stehen weiter unter Nachrichten.",
    "verify": {
      "brandTag": "Verifizieren",
      "title": "Verifiziere dich zum Schreiben",
      "sub": "Schauen und Herzen kann jeder. Für ein Gespräch brauchen wir deinen Ausweis und ein kurzes Bestätigungsvideo. Eingereicht genügt — die Prüfung kann warten.",
      "cta": "Ausweis und Video hinzufügen",
      "videoCta": "Bestätigungsvideo hinzufügen",
      "submitted": "Ausweis und Video sind da. Du kannst schreiben, während wir prüfen.",
      "done": "Du bist verifiziert.",
      "back": "Zurück",
      "continue": "Weiter",
      "idEyebrow": "Identität",
      "videoEyebrow": "Präsenz",
      "idText": "Reisepass oder Personalausweis. Nichts davon wird öffentlich gezeigt. Eingereicht genügt zum Schreiben.",
      "videoText": "Ein kurzer Clip (etwa {seconds} Sekunden). Schau in die Kamera. Das zeigt, dass du wirklich da bist."
    }
  },
  "chat": {
    "brandTag": "Chatten",
    "unavailableTitle": "Chat nicht verfügbar",
    "unavailableText": "Diese Übereinstimmung fehlt oder gehört nicht zu deiner Sitzung.",
    "backToMatches": "Zurück zu den Übereinstimmungen",
    "backMatches": "← Übereinstimmungen",
    "valuesSubscriber": "Werte {score} · Abonnent",
    "valuesTrial": "Werte {score} · Testversion",
    "valuesKept": "Werte {score} · Übereinstimmung beibehalten",
    "empty": "Begrüßen du mit Bedacht. Im gemeinsamen Backend werden Nachrichten nach einer gegenseitigen Übereinstimmung auf beiden Telefonen synchronisiert.",
    "placeholder": "Nachricht {name}…",
    "ariaMessage": "Nachricht",
    "send": "Schicken"
  },
  "billing": {
    "paywallCopy": "Behalte nach deiner kostenlosen Testversion alle, mit denen du bereits gematcht hast, und chatte weiter. Um neue Leute zu sehen, abonniere.",
    "signInToMatch": "Meld dich an, um den Abgleich zu nutzen.",
    "signInFirst": "Meld dich zuerst an.",
    "subscriberUntil": "Abonnent · bis {date}",
    "renewal": "Erneuerung",
    "freeTrial": "Kostenlose Testversion · {days} Tage (endet {date})",
    "soon": "bald",
    "trialEnded": "Testversion beendet · Matches und Chat bleiben geöffnet",
    "subscribe": "Abonnieren · ${price}/Monat",
    "subscribeEarly": "Frühzeitig abonnieren · ${price}/Monat",
    "activeNote": "Abonnement aktiv – du kannst neue Leute wieder sehen.",
    "playOnly": "Abonnement nur über Google Play Billing (App-Installation). Hier gibt es keinen Web-Checkout.",
    "playOnlyShort": "Abrechnung nur über Google Play — keine Web-Zahlung."
  },
  "auth": {
    "recoveryTitle": "Speicher deinen Wiederherstellungscode",
    "recoveryText": "Schreib das jetzt auf. Es wird einmal angezeigt. Wenn du deine Passphrase verlierst, ist dieser Code die einzige Möglichkeit, sie im geschlossenen Test zurückzusetzen.",
    "savedContinue": "Ich habe es gespeichert – weiter",
    "welcomeBack": "Willkommen zurück",
    "createAccount": "Erstell dein Konto",
    "intro": "Handle und Passphrase. Es wird keine E-Mail oder SMS versendet. Deine ID bleibt während des Onboardings, der Überprüfung und des Abgleichs stabil.",
    "tabLogin": "Einloggen",
    "tabRegister": "Registrieren",
    "handle": "Handhaben",
    "handlePlaceholder": "you@example.com oder ein kurzer Handle",
    "passphrase": "Passphrase",
    "passphrasePlaceholder": "Mindestens 8 Zeichen",
    "submitLogin": "Einloggen",
    "submitRegister": "Benutzerkonto erstellen",
    "backWelcome": "Zurück zur Begrüßung"
  },
  "options": {
    "origin": {
      "african": "afrikanisch",
      "european": "europäisch",
      "asian": "asiatisch",
      "latino": "Latino / Hispanoamerikaner",
      "middleEastern": "Naher Osten",
      "indigenous": "Einheimisch",
      "mixed": "Gemischt",
      "other": "Andere",
      "dutch": "Niederländisch",
      "german": "Deutsch",
      "any": "Offen – egal"
    },
    "interest": {
      "prayer": "Gebet",
      "worship": "Verehrung",
      "reading": "Lektüre",
      "hiking": "Wandern",
      "music": "Musik",
      "cooking": "Kochen",
      "farming": "Landwirtschaft / Gartenarbeit",
      "sports": "Sport",
      "missions": "Missionen",
      "family": "Familienleben",
      "crafts": "Kunsthandwerk",
      "outdoors": "Draußen"
    }
  },
  "capture": {
    "yesNoDefaults": {
      "yes": "Ja",
      "no": "NEIN"
    },
    "id": {
      "titleEmpty": "Regierungsausweis",
      "titleReady": "Ausweis bereit",
      "hintEmpty": "Reisepass oder Personalausweis. Mach ein Live-Foto oder wählen du ein Bild/PDF aus. Alle vier Ecken sichtbar.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "savedSuffix": "· gespeichert",
      "previewAlt": "Vorschau des Regierungsausweises",
      "pdfAria": "PDF-Dokument ausgewählt",
      "takePhoto": "Mach ein Foto",
      "retake": "Wiederholung",
      "chooseFile": "Datei auswählen",
      "replaceFile": "Datei ersetzen",
      "remove": "Entfernen",
      "uploading": "Hochladen…",
      "cameraTitle": "Fotografier deinen Ausweis",
      "signIn": "Meld dich an, bevor du deinen Ausweis hochlädst.",
      "uploadFailed": "Der Upload ist fehlgeschlagen. Versuch es erneut.",
      "badFile": "Diese Datei konnte nicht verwendet werden."
    },
    "video": {
      "titleEmpty": "Bestätigungsvideo",
      "titleLive": "Kamera live",
      "titleReady": "Video fertig",
      "hintEmpty": "Sag deinen Vornamen und dass du UN8 ehrlich beitrittst. 5–15 Sekunden.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "rec": "REC {seconds}s",
      "record": "Aufzeichnen",
      "cameraUpload": "Kamera-Upload",
      "chooseFile": "Datei auswählen",
      "startRecording": "Aufnahme starten",
      "cancel": "Stornieren",
      "stopSave": "Stoppen und speichern",
      "recordAgain": "Nochmals aufnehmen",
      "replaceFile": "Datei ersetzen",
      "remove": "Entfernen",
      "unsupported": "Eine Live-Aufzeichnung ist hier nicht verfügbar. Benutze den Kamera-Upload oder wähl eine Datei aus.",
      "permissionDenied": "Kameraberechtigung verweigert. Du kannst weiterhin eine kurze Videodatei hochladen.",
      "signIn": "Meld dich an, bevor du ein Video hochlädst.",
      "uploadFailed": "Der Upload ist fehlgeschlagen. Versuch es erneut.",
      "saveFailed": "Die Aufnahme konnte nicht gespeichert werden.",
      "badVideo": "Dieses Video konnte nicht verwendet werden."
    },
    "photos": {
      "count": "{count} / {max} Fotos",
      "minimumMet": "Minimum erfüllt",
      "moreRequired": "{n} mehr erforderlich",
      "listAria": "Verifizierungsfotos",
      "photoAlt": "Foto {n}",
      "removeAria": "Foto entfernen {n}",
      "camera": "Kamera",
      "takePhoto": "Mach ein Foto",
      "chooseFiles": "Dateien auswählen",
      "uploading": "Hochladen…",
      "hint": "Foto aufnehmen öffnet die Live-Kamera. „Dateien auswählen“ ist nur für Galerieauswahlen geeignet. Klare Gesichtsaufnahmen – keine Filter, die die Identität verbergen. Max {max}.",
      "cameraTitle": "Mach ein Foto von dir",
      "signIn": "Meld dich an, bevor du Fotos hochlädst.",
      "someFailed": "Einige Fotos konnten nicht hochgeladen werden. Versuch es erneut mit den fehlgeschlagenen Versuchen.",
      "addFailed": "Fotos konnten nicht hinzugefügt werden."
    },
    "liveStill": {
      "titleDefault": "Kamera",
      "close": "Schließen",
      "capture": "Erfassen",
      "cancel": "Stornieren",
      "hint": "Bleib ruhig. Die Live-Kamera bleibt offen, bis du ein Foto machst.",
      "unavailable": "Die Kamera ist in diesem Browser nicht verfügbar. Benutze stattdessen Datei auswählen.",
      "permissionDenied": "Kameraberechtigung verweigert oder nicht verfügbar. Benutze stattdessen Datei auswählen.",
      "frameFailed": "Dieses Bild konnte nicht erfasst werden.",
      "saveFailed": "Das Foto konnte nicht gespeichert werden."
    },
    "uploadStatus": {
      "uploading": "Hochladen…",
      "failed": "Hochladen fehlgeschlagen",
      "savedLocally": "lokal gespeichert",
      "uploaded": "hochgeladen",
      "stored": "gelagert",
      "awaitingUpload": "Warten auf Upload",
      "localFallbackNote": "{error} Datei wird auf diesem Gerät gespeichert; Versuch es erneut, wenn der Signierungsendpunkt aktiv ist."
    }
  },
  "language": {
    "label": "Sprache",
    "choose": "Sprache wählen"
  },
  "shell": {
    "back": "Zurück",
    "goBackAria": "Geh zurück"
  },
  "questionnaire": {
    "skipForNow": "Vorerst überspringen",
    "skipConsequence": "Ausgefüllte Profile werden zuerst angezeigt.",
    "confirm": "Weiter",
    "progressLabel": "{current} von {total}",
    "fewSentences": "Einige Sätze",
    "ancestryNote": "Dies ist eine Präferenz, die nur das Ranking beeinflusst — niemand wird ausgeblendet."
  }
} as Messages;
